<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Заказы</h1>
        </div>
      </div>
    </section>

    <section>
      <TableFilter
        :tabs="tabsFilter"
        @setActiveTab="setTabsFilter"
        :propActiveTabIndex="activeTabIndex"
        style="margin-top: 32px"
        :loading="tabLoading"
      />
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm :value="searchValue" @form-submit="setSearchValue" />
          </div>
        </div>
        <div class="page__item" style="margin-left: 16px;width: 100%">
          <div class="page__row">
            <CustomFilter style="margin-right: 16px" right="-80px">
              <b>Настройка</b>
              <div class="header__options">
                <AppCheckbox
                  v-for="(header, index) in tableHeaders.headers"
                  :key="index + 'header'"
                  :title="header.title"
                  :checked="header.shown"
                  @toggle-check="toggleHeaderOption(index)"
                />
              </div>
            </CustomFilter>

            <div class="page__item order__controls" v-if="roleAccessCreate">
              <transition name="fade">
                <AppButtonSmRemove
                  v-if="isActiveDelete && roleAccessRemove"
                  title="Удалить"
                  @click.stop.native="showRemoveConfirmation"
                />
              </transition>
              <transition name="fade">
                <AppButtonSmElect
                  v-if="isActiveDelete && activeTabIndex !== 2"
                  title="В избранное"
                  @addToElect="addToElect"
                />
              </transition>
              <transition name="fade">
                <AppButtonSmRemove
                  v-if="isActiveDelete && activeTabIndex === 2"
                  title="Удалить из избранного"
                  @click.stop.native="(id) => showRemoveConfirmation(id, true)"
                  icon="minus"
                />
              </transition>
              <AppButtonSmAdd
                title="Создать"
                @click.stop.native="goToPvhUpdate('create')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="page__table mb-20" v-if="pvh.length !== 0">
        <!-- :filters="[{name: 'Статус', selectedCount: 4, callback: () => {}}, {name: 'Статус', callback: () => {}}]" -->
        <AppTable
          :data="pvh"
          isSpecial
          :loading="tabLoading"
          :headers="tableHeaders.headers.filter(header => header.shown)"
          :has-checkbox="roleAccessRemove"
          :all-items-active="tableHeaders.allActive"
          @toggle-active-item="toggleActiveItem"
          @toggle-active-all="toggleActiveAll"
          @edit-this-item="goToPvhUpdate"
          @show-this-item="goToPvhUpdate"
          @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records page__no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены" />
        </div>
      </div>
    </section>

    <section class="section page__footer page__footer_has-pagination">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade" v-if="roleAccessRemove">
      <AppConfirmation
        v-if="removeConfirmation.active"
        :text="removeConfirmation.text"
        @confirm="removePvh"
        @reject="closeRemoveConfirmation"
      />
    </transition>

    <ThePagePreloader v-if="isLoading" />
  </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppButtonSmElect from '@/components/page/button/AppButtonSmElect'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import CustomFilter from '@/components/page/modal/CustomFilter'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import TableFilter from '@/components/page/table/TableFilter'
import VPagination from '@/components/page/VPagination'

export default {
  name: 'PvhOrderList',
  components: {
    AppButtonSmRemove,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    CustomFilter,
    AppCheckbox,
    TableFilter,
    AppButtonSmElect,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        text: 'Вы действительно хотите удалить эти заказы?',
        electOnly: false
      }
    }
  },
  computed: {
    tableHeaders () {
      return this.$store.getters.getPvhOrderListTableHeaders
    },
    tabsFilter () {
      return this.$store.getters.getPvhOrderListTabsFilter
    },
    activeTabIndex () {
      return this.$store.getters.getActiveTabIndex
    },
    pvh () {
      return this.$store.getters.getPvhOrderList?.map(pvh => {
        const statusCom = [
          pvh.status,
          pvh.comments?.length ? `Комментариев: ${pvh.comments.length}` : ''
        ]
        // pvh-bold выделение mod
        return {
          id: pvh.id,
          isControlsActive: pvh.isControlsActive,
          isActive: pvh.isActive,
          values: [
            { data: statusCom, mod: 'pvhComments' },
            { data: pvh.code, mod: '' },
            { data: pvh.client.name, mod: '' },
            { data: pvh.client.address, mod: '' },
            { data: pvh.client.telephone, mod: '', link: true },
            { data: pvh.value, mod: '' },
            { data: pvh.gauger, mod: '' },
            { data: pvh.installer, mod: '' },
            { data: pvh.deliveryMethod, mod: '' },
            { data: pvh.availability_date, mod: '' },
            { data: pvh.order_type, mod: '' },
            { data: pvh.contractor, mod: '' },
            { data: pvh.installation_date, mod: '' },
            { data: pvh.gauging_date, mod: '' },
            { data: pvh.square_meters, mod: '' },
            { data: pvh.count, mod: '' },
            { data: pvh.code_ral, mod: '' },
            { data: pvh.depth, mod: '' },
            { data: pvh.created_at, mod: '' },
            { data: pvh.updated_at, mod: '' },
            { data: pvh.creator, mod: '' }
          ].filter((val, i) => this.tableHeaders.headers[i].shown)
        }
      })
    },
    selectPvh () {
      return this.$store.getters.getPvhOrderList?.filter(item => item.isActive)
    },
    searchValue () {
      return this.$store.getters.getPvhOrderListSearchValue
    },
    filter () {
      return this.$store.getters.getPvhOrderListFilter
    },
    pagination () {
      return this.$store.getters.getPvhOrderListPagination
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isActiveDelete () {
      return this.$store.getters.getPvhOrderListIsActiveDelete
    },
    isLoading () {
      return this.$store.getters.getPvhOrderListIsLoading
    },
    tabLoading () {
      return this.$store.getters.getTabLoading
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightPvh.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightPvh.actions.remove
    }
  },
  methods: {
    goToPvhUpdate (id) {
      this.$router.push({ name: 'PvhOrderUpdate', params: { id } })
    },
    toggleItemControls (itemId) {
      this.$store.dispatch('togglePvhOrderListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('togglePvhOrderListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('togglePvhOrderListItemActiveAll')
    },
    showRemoveConfirmation (id, isElect = false) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
      this.removeConfirmation.electOnly = isElect
      this.removeConfirmation.text = isElect
        ? 'Вы действительно хотите удалить эти заказы из избранного?'
        : 'Вы действительно хотите удалить эти заказы?'
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removePvh () {
      const { electOnly } = this.removeConfirmation
      this.$store.dispatch('removePvh', electOnly)
      this.removeConfirmation.active = false
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('setPvhOrderListSearchValue', value)
    },

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('getPvhOrderListPage', pageNum)
    },

    setTabsFilter (tab, i) {
      this.$store.dispatch('setPvhOrderListActiveTabs', i)
    },

    toggleHeaderOption (index) {
      this.$store.dispatch('setTableHeaders', index)
    },
    addToElect () {
      this.$store.dispatch('addPvhToElect', this.selectPvh.map(({ id }) => id))
    }
  },
  mounted () {
    this.$store.dispatch('getPvh')
  },
  destroyed () {
    this.$store.commit('RESET_PVH_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.order__controls {
  display: flex;
  column-gap: 16px;
  margin-left: auto;
}

.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}

.header__options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 16px;
  margin-top: 16px;
}

.filter {
  margin: auto 16px auto 0;
}
</style>
